import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { Divider } from "@/components/ui/divider";
import React, {useContext} from 'react';
import InputHandle from "../basic/InputHandle";
import OutputHandle from "../basic/OutputHandle";
import NodeView from "./NodeView";
import i18n from "i18n-js";
import {MediaContext} from "../media/MediaContext";


export default function DecideNode({id, data, selected}) {
    const {flowId, nodeHighlighting} = useContext(MediaContext)

    return (
        <NodeView id={id} data={data} selected={selected} disabled={flowId == 'showFlow'} nodeHighlighting={nodeHighlighting[id]}>
            <View>
                <VStack space='md' className="rounded-b-md pb-3 items-center bg-primary-50">
                    <Divider/>
                    <Text className="font-bold text-primary-900 text-lg">{i18n.t('showStep.onYes')}:</Text>
                    <Divider/>
                    <Text className="font-bold text-primary-900 text-lg">{i18n.t('showStep.onNo')}:</Text>
                </VStack>
                <OutputHandle id='yes' position={24} nodeHighlighting={nodeHighlighting[id]}/>
                <OutputHandle id='no' position={65} nodeHighlighting={nodeHighlighting[id]}/>
            </View>
            <InputHandle nodeHighlighting={nodeHighlighting[id]}/>
        </NodeView>
    );
}